import type { AuthUser } from './types';
import { getRoleKey } from './roleUtils';

export interface DashboardRouteOptions {
  email?: string;
}

/**
 * Resolves the post-login / dashboard route for a user based on role and account state.
 */
export function getDashboardRoute(
  user: AuthUser,
  basename = process.env.PUBLIC_URL || '',
  options: DashboardRouteOptions = {}
): string {
  const roleKey = getRoleKey(user);
  const state = user.state || '';

  if (state.includes('PRF')) {
    switch (roleKey) {
      case 'superuser':
        return '/su/otp';
      case 'superadmin':
        return '/sa/otp';
      case 'admin':
        return `${basename}/profile/${user.userId}`;
      case 'client':
        return `${basename}/profile/${user.userId}`;
      default:
        return `${basename}/profile/${user.userId}`;
    }
  }

  switch (roleKey) {
    case 'superuser':
      return '/su/dashboard';
    case 'superadmin':
      return '/sa/dashboard';
    case 'admin':
      return '/admin/dashboard';
    case 'sme':
      return '/sme/dashboard';
    case 'client':
    default:
      return `${basename}/project`;
  }
}

export function getDashboardRouteState(
  user: AuthUser,
  options: DashboardRouteOptions = {}
): Record<string, unknown> | undefined {
  const roleKey = getRoleKey(user);
  const state = user.state || '';

  if (state.includes('PRF') && (roleKey === 'superuser' || roleKey === 'superadmin')) {
    return {
      email: options.email,
      userId: user.userId,
    };
  }

  return undefined;
}
